export default IconPacman => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-pacman" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5.636 5.636a9 9 0 0 1 13.397 .747l-5.619 5.617l5.619 5.617a9 9 0 1 1 -13.397 -11.981z" />
  <circle cx="11.5" cy="7.5" r="1" fill="currentColor" />
</svg>`;